import {del, get, patch, post} from './http'

/**
 * 获取点播playauth
 */
export const getVideoRes = (aliVid) => get('https://apis.study.laodao.so/tool/vod/' + aliVid, {})

/**
 * 阿里云封面编辑
 */
export const aliEditVideoPic = (params) => get('tool/vod/update/coverurl', params)

/**
 * 系统视频库视频列表 2019.7.15
 */
export const getLdVideoList = (params) => get('tradeapp/video/list', params)

/**
 * 系统视频库分类列表 2019.7.18
 */
export const getVideoClassList = () => get('tradeapp/video/class/list', {})


/**
 * 添加视频库分类
 * @param params
 */
export const addvideotype = (params) => post('tradeapp/video/library/class', params)

/**
 * 编辑视频分类
 * @param params
 */
export const editvideotype = (params) => patch('tradeapp/video/library/class', params)

/**
 * 获取视频库分类列表
 * @param params
 */
export const getvideolibtypelist = (params) => get('tradeapp/video/library/class/list', params)


/**
 * 视频库分类详情
 * @param classId
 */
export const getvideolibtypedetail = (classId) => get('tradeapp/video/library/class/' + classId, {})

/**
 * 删除是屁库分类
 * @param params
 */
export const delVideolibtypes = (params) => del('tradeapp/video/library/class', params)


/**
 * 根据类别的视频列表
 * @param params
 */
export const getcustomvideolistbytype = (params) => get('tradeapp/video/library/list', params)


export const throwVideolib = (params) => post('tradeapp/video/library', params)

/**
 * 批量删除视频
 * @param params
 */
export const delVideoList = (params) => del('tradeapp/video/library', params)


/**
 * 编辑系统视频
 * @param videoId
 * @param params
 */
export const editSysVideo = (videoId, params) => patch('tradeapp/video/library/' + videoId, params)
